import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import queryString from 'query-string';
import moment from 'moment';
import { translate } from 'react-i18next';
import MapWithRouter from '../containers/MapWithRouter';
import { TileLayer, BingSource, VectorLayer, VectorSource, ClusterSource } from '../ol';
import SideBar from '../layout/SideBar';
import SideBarNavigationLink from '../layout/SideBarNavigationLink';
import MainNavigation from '../layout/MainNavigation'
import Content from '../layout/Content';
import Button from '../layout/Button';
import ScheduleShow from '../schedules/Show';
import ScheduleEdit from '../schedules/Edit';
import ScheduleNew from '../schedules/New';
import ScheduleList from '../schedules/List';
import { Icon } from '../icons';
import styles from './show.scss';

import { getFeaturesBySchedule, toFeature, getFeaturesWithoutASchedule } from '../../reducers/devices';
import {
  clusterStyles,
  defaultProfileStyles,
  activeProfileStyles,
} from '../../mapStyles';

import {
  publish,
} from '../../actions/events';

class Show extends Component  {
  constructor(props) {
    super(props);

    this.state = {
      featuresBySchedule: {},
      allFeatures: [],
      featuresWithoutASchedule: [],
      shouldZoomToFit: props.location.search ? false : true,
    }

    this.onClustersReady = this.onClustersReady.bind(this);
    this.onPublishClick = this.onPublishClick.bind(this);
  }

  componentDidMount() {
    const { devices, event } = this.props;
    this.setState({
      allFeatures: devices.map(toFeature),
      featuresBySchedule: getFeaturesBySchedule(devices, event.schedules || []),
      featuresWithoutASchedule: getFeaturesWithoutASchedule(devices, event.schedules || [])
    })
  }

  componentDidUpdate(prevProps) {
    // if((prevProps.profiles !== this.props.profiles) || prevProps.devices !== this.props.devices ) {
    //   this.setState({
    //     featuresByProfile: getFeaturesByProfile(this.props.devices),
    //     allFeatures: this.props.devices.map(toFeature)
    //   });
    // }
  }

  onClustersReady(vectorSource) {
    if (this.state.shouldZoomToFit) {
      const extent = vectorSource.getExtent();
      if(extent[0] !== Infinity) {
        this.refs.map_component.zoomToExtent(extent);
      }
    }
  }

  onPublishClick() {
    const { organisationId, event } = this.props;
    this.props.onPublishClick(organisationId, event.id);
  }

  render() {
    const { organisationId, event, match, location, history } = this.props;
    const { allFeatures, featuresWithoutASchedule, featuresBySchedule } = this.state;

    const activeScheduleId = match.params.scheduleId && match.params.scheduleId !== 'new' ? match.params.scheduleId : undefined;
    // Should this be here!?
    const { zoom } = queryString.parse(location.search)

    return (
      <div>
        <div className="grid">
          <SideBar>
            {event.status === "created" && (
              <ul className="profile-list">
                <SideBarNavigationLink to={`/organisations/${organisationId}/events/${event.id}/schedules/new`}>
                  <Icon type={'plus'} className="profile-icon"/>
                  <div className="profile-name">{t('CREATE_NEW_EVENT_SCHEDULE')}</div>
                </SideBarNavigationLink>
              </ul>
            )}
            <ScheduleList event={event} />
          </SideBar>
          <Content>
            <MapWithRouter ref="map_component" location={location} history={history}>
              <TileLayer opacity={1}>
                <BingSource
                  apiKey="Aq2UtqLl3bUrVvpxt7J49h6wfWpZ8pDWKzIqn2veRBx1VzJf6P-GnzKv7AvL3FLA"
                  imagerySet="CanvasGray"
                  maxZoom={19} />
              </TileLayer>
              <VectorLayer style={clusterStyles} visible={zoom <= 13}>
                <ClusterSource features={allFeatures} onReady={this.onClustersReady} />
              </VectorLayer>
              <VectorLayer style={defaultProfileStyles} visible={zoom > 13}>
                <VectorSource features={featuresWithoutASchedule} />
              </VectorLayer>
              {event.schedules && event.schedules.map(schedule =>
                <VectorLayer visible={zoom > 13} zIndex={activeScheduleId === schedule.id ? 1 : 0} key={schedule.id} style={activeScheduleId === schedule.id ? activeProfileStyles : defaultProfileStyles}>
                  <VectorSource features={featuresBySchedule[schedule.id]} />
                </VectorLayer>
              )}
            </MapWithRouter>
          </Content>


          <TransitionGroup>
            <CSSTransition key={location.pathname} timeout={800} classNames={isNewOrEdit(location.pathname) ? 'fade' : 'slide-right'}>
              <div>
                <Switch location={this.props.location}>
                  <Route exact path="/organisations/:organisationId/events/:eventId/schedules/new" component={ScheduleNew} />
                  <Route exact path="/organisations/:organisationId/events/:eventId/schedules/:scheduleId" component={ScheduleShow} />
                  <Route exact path="/organisations/:organisationId/events/:eventId/schedules/:scheduleId/edit" component={ScheduleEdit} />
                </Switch>
              </div>
            </CSSTransition>
          </TransitionGroup>

        </div>
        <MainNavigation>
          <div className="creating-event-container">
            <div className="creating-event-message">{t('EVENT')}:</div>
            <div className="creating-event-name">{event.description}</div>
            <div className="creating-event-date">{moment(event.event_date).format("DD-MM-YYYY")}</div>
            {event.status === "created" &&
              <Button onClick={this.onPublishClick}>{t('PUBLISH')}</Button>
            }
            {event.status === "published" &&
              <span>{t('EVENT_PUBLISHED_ON')} {moment(event.modified).format("DD-MM-YYYY HH:mm")}</span>
            }
          </div>
        </MainNavigation>
      </div>
    )
  }
}

function isNewOrEdit(pathname) {
  const last_element = pathname.split('/').slice(-1)
  return last_element == 'new' || last_element == 'edit';
}

export default translate('events')(withRouter(connect(
  ( { events, devices }, { match } ) => ({
    organisationId: match.params.organisationId,
    event: events.data.find(event => event.id === match.params.eventId),
    devices: devices.data,
  }),
  { onPublishClick: publish }
)(Show)));



// WEBPACK FOOTER //
// ./src/components/events/Show.js